import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=e1aad5fa&scoped=true&"
import script from "./SidebarComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarComponent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarComponent.vue?vue&type=style&index=0&id=e1aad5fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1aad5fa",
  null
  
)

export default component.exports